/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import { FaCircleNotch, FaPowerOff } from 'react-icons/fa'
import { TiSpanner } from 'react-icons/ti'

import AssetTableCell from './AssetTableCell'
import { createTooltip } from './utils'

type PowerStateIconProps = {
  powerState: string
  powerStateSampleTime?: Date
  maintenanceMode: boolean
  maintenanceModeEventSampleTime?: Date
}

const reeferOn = 'Reefer On'
const reeferOff = 'Reefer Off'

const renderPowerIcon = (powerState: string, isInMaintenanceMode: boolean) => {
  switch (powerState) {
    case 'Reefer On':
      return isInMaintenanceMode ? (
        <TiSpanner className="w-4 h-4 text-green-500" />
      ) : (
        <FaPowerOff className="w-4 h-4 text-green-500" />
      )
    case 'Reefer Off':
      return isInMaintenanceMode ? (
        <TiSpanner className="w-4 h-4 text-gray-500" />
      ) : (
        <FaCircleNotch className="w-4 h-4 text-gray-500" />
      )
    default:
      return <></>
  }
}

const PowerStateIcon: React.FC<PowerStateIconProps> = ({
  powerState,
  powerStateSampleTime,
  maintenanceModeEventSampleTime,
  maintenanceMode,
}) => {
  const reeferTooltip = createTooltip(powerState === reeferOn ? reeferOn : reeferOff, powerStateSampleTime)
  const maintenanceModeTooltip = maintenanceMode
    ? createTooltip('Maintenance mode', maintenanceModeEventSampleTime)
    : null
  let tooltip = ''
  if (reeferTooltip && maintenanceModeTooltip) {
    tooltip = `${maintenanceModeTooltip}\n${reeferTooltip}`
  } else if (reeferTooltip) {
    tooltip = reeferTooltip
  } else if (maintenanceModeTooltip) {
    tooltip = maintenanceModeTooltip
  } else {
    tooltip = 'Maintenance mode'
  }
  return (
    <AssetTableCell tooltip={tooltip}>
      <div className="w-full h-full flex items-center justify-center">
        {renderPowerIcon(powerState, maintenanceMode)}
      </div>
    </AssetTableCell>
  )
}

export default PowerStateIcon
